import { render, staticRenderFns } from "./PropertyStats.vue?vue&type=template&id=48c624f3&"
import script from "./PropertyStats.vue?vue&type=script&lang=ts&"
export * from "./PropertyStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports